import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function OilGasServices() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen" dir="ltr">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-[1300] overflow-visible h-[72px]">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-[72px]">
            <Link className="flex items-center" to="/">
              <img 
                alt="VIPA Trading Company" 
                className="h-12 w-auto" 
                src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
              />
            </Link>
            
            <nav className="hidden lg:flex items-center space-x-8">
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/">
                Home
              </Link>
              <div className="relative">
                <button 
                  className="text-[#E71B25] hover:text-[#d11620] transition-colors font-medium flex items-center cursor-pointer whitespace-nowrap focus:outline-none focus:text-[#E71B25]"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Services
                  <i className={`ri-arrow-down-s-line ml-1 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-0 min-w-[260px] bg-white rounded-lg shadow-lg border border-[#C3AAAB33] z-[1000]">
                    <div className="py-2">
                      <Link to="/services/construction" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Construction & Roads
                      </Link>
                      <Link to="/services/oil" className="block px-4 py-3 text-[#E71B25] bg-[#F7F7F7] hover:text-[#d11620] transition-colors text-left font-medium">
                        Oil & Gas
                      </Link>
                      <Link to="/services/gold" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Gold Trading
                      </Link>
                      <Link to="/services/defense" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Defense Systems
                      </Link>
                      <Link to="/services/consultation" className="block px-4 py-3 text-[#595A5C] hover:bg-[#F7F7F7] hover:text-[#E71B25] transition-colors text-left">
                        Consulting
                      </Link>
                    </div>
                  </div>
                )}
              </div>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/about">
                About Us
              </Link>
              <Link className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium" to="/contact">
                Contact
              </Link>
            </nav>

            <div className="hidden lg:flex items-center space-x-4">
              <a data-lang="ar" className="text-[#595A5C] hover:text-[#E71B25] transition-colors font-medium cursor-pointer">
                العربية
              </a>
              <Link to="/contact">
                <button 
                  type="button" 
                  className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap border-2 border-[#E71B25] text-[#E71B25] hover:bg-[#E71B25] hover:text-white px-4 py-2 text-sm"
                >
                  Contact Us
                </button>
              </Link>
            </div>

            <button 
              className="lg:hidden text-[#595A5C] cursor-pointer" 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </header>

      <main>
        {/* Hero Section */}
        <section className="relative py-24 bg-gradient-to-br from-[#596A78] to-[#4a5661] overflow-hidden">
          <div 
            className="absolute inset-0 bg-cover bg-center opacity-60"
            style={{ 
              backgroundImage: `url(https://public.readdy.ai/ai/img_res/359cf06381da924d09cbdec64c887dea.jpg)` 
            }}
          ></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center text-white">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                Oil & Gas
              </h1>
              <p className="text-xl md:text-2xl leading-relaxed max-w-3xl mx-auto">
                We provide integrated solutions for the oil & energy sector — from equipment and material supply to operations and maintenance — aligned with international standards.
              </p>
            </div>
          </div>
        </section>

        {/* Service Scope */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-8">Our Service Scope</h2>
                <div className="space-y-6">
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Supply of specialized equipment and materials
                    </p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Operation and maintenance (O&M) services
                    </p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      API 650/653 pipelines and storage tanks
                    </p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Non-destructive testing (NDT) services
                    </p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Health, Safety &amp; Environment (HSE) compliance
                    </p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Facility installation and commissioning
                    </p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Process optimization and efficiency enhancement
                    </p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-6 h-6 bg-[#E71B25] rounded-full mr-4 flex-shrink-0 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-lg text-[#595A5C] leading-relaxed">
                      Emergency response and safety management
                    </p>
                  </div>
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/6b300437e014701817d53100b34fc0a7.jfif"
                  alt="Oil & Gas Services"
                  className="w-full h-auto rounded-xl shadow-lg object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Compliance & Safety */}
        <section className="py-20 bg-[#F7F7F7]">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-6">Compliance &amp; Safety</h2>
              <div className="w-20 h-1 bg-[#E71B25] mx-auto mb-8"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-microscope-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">NDT Testing</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Advanced NDT ensuring integrity &amp; quality.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-heart-pulse-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">HSE Standards</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Full compliance with HSE.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-check-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">API 650/653</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  API standards for tanks &amp; pipelines.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose VIPA */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#2B2C2E] mb-6">Why Choose VIPA?</h2>
              <div className="w-20 h-1 bg-[#E71B25] mx-auto mb-8"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-user-star-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Specialized Team</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Proven oil &amp; gas expertise.
                </p>
              </div>

              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-tools-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">Advanced Technologies</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Latest inspection/operation tech.
                </p>
              </div>

              <div className="bg-[#F7F7F7] rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-global-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#2B2C2E] mb-4">International Partnerships</h3>
                <p className="text-[#595A5C] leading-relaxed">
                  Trusted global suppliers.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <section className="py-20 bg-[#E71B25] text-white">
          <div className="container mx-auto px-4 max-w-4xl text-center">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">Need Comprehensive Oil &amp; Gas Solutions?</h2>
            <p className="text-xl mb-8 leading-relaxed">
              Get a free consultation and a customized quote.
            </p>
            <Link to="/contact?subject=Oil%20%26%20Gas">
              <button 
                type="button" 
                className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap bg-white text-[#E71B25] hover:bg-gray-100 shadow-sm hover:shadow-md px-8 py-4 text-lg"
              >
                Request a Quote
              </button>
            </Link>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#2B2C2E] text-white">
        <div className="container mx-auto px-4 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2 space-y-6">
              <div>
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 flex items-center justify-center mr-4">
                    <img 
                      alt="VIPA Trading Company" 
                      className="h-16 w-auto" 
                      src="https://static.readdy.ai/image/b722d8dcf1c144135667d61789b02d4e/99b5c3dffef714fa12a155204a44cba1.png"
                    />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white mb-1">VIPA Trading Company</h2>
                    <p className="text-[#E71B25] text-sm font-medium">شركة فيبا التجارية</p>
                  </div>
                </div>
                <p className="text-gray-300 text-base leading-relaxed mb-6">
                  A leading Kuwaiti multi-activity company that works in engineering, oil, trading, armament, and consulting with the highest international standards.
                </p>
                <div className="space-y-3">
                  <a href="mailto:info@vipatradingco.com" className="text-gray-300 hover:text-[#E71B25] transition-colors text-base inline-flex items-center cursor-pointer group">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3 group-hover:bg-[#E71B25] transition-colors">
                      <i className="ri-mail-line text-sm"></i>
                    </div>
                    info@vipatradingco.com
                  </a>
                  <div className="text-gray-300 text-base inline-flex items-center">
                    <div className="w-8 h-8 bg-gray-700 rounded-lg flex items-center justify-center mr-3">
                      <i className="ri-phone-line text-sm"></i>
                    </div>
                    Kuwait
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Our Services
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/construction"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Construction</Link></li>
                <li><Link className="text-[#E71B25] hover:text-[#d11620] transition-colors text-base cursor-pointer block group" to="/services/oil"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Oil & Gas</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/trading"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Trading</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/armament"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Armament</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/services/consulting"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Consulting</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-white font-bold text-xl mb-8 relative">
                Quick Links
                <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-[#E71B25]"></div>
              </h3>
              <ul className="space-y-4">
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Home</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/about"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>About Us</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/contact"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Contact</Link></li>
                <li><Link className="text-gray-300 hover:text-[#E71B25] transition-colors text-base cursor-pointer block group" to="/careers"><i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform"></i>Careers</Link></li>
              </ul>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-600">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <p className="text-gray-400 text-sm">© 2025 VIPA Trading Company — All rights reserved.</p>
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="flex items-center gap-4">
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-linkedin-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-instagram-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-700 hover:bg-[#E71B25] rounded-lg flex items-center justify-center transition-colors text-lg cursor-pointer group">
                    <i className="ri-twitter-fill group-hover:scale-110 transition-transform"></i>
                  </a>
                </div>
                <div className="flex items-center gap-3 md:border-l md:border-gray-600 md:pl-4">
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-medal-line text-[#E71B25]"></i>
                    <span>API Certified</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-shield-check-line text-[#E71B25]"></i>
                    <span>HSE Compliant</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}